module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-global-map.2f3238e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-global-map.jpg
// module id = 3165
// module chunks = 11